/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".edit-remark_text__formfield[_ngcontent-%COMP%]{width:100%}.edit-remark_text__textarea[_ngcontent-%COMP%]{height:200px;width:100%;border:1px solid #d3d3d3;line-height:1.24;font-size:14px;display:block;margin-left:auto;margin-right:auto}.edit-remark__headertext[_ngcontent-%COMP%]{line-height:1.24;font-size:14px}"];
export { styles as styles };
